import api from './api';

export interface TipoDocumentoDeloitte {
  id: string;
  nomeDocumento: string;
  critico: boolean;
  enabled: boolean;
}

export interface CreateTipoDocumentoDeloitteRequest {
  nomeDocumento: string;
  critico: boolean;
}

export interface UpdateTipoDocumentoDeloitteRequest {
  id: string;
  nomeDocumento: string;
  critico: boolean;
}

export const getAllTiposDocumentoDeloitte = () =>
  api.get<TipoDocumentoDeloitte[]>('tiposDocumentoDeloitte');

export const createTipoDocumentoDeloitte = (data: CreateTipoDocumentoDeloitteRequest) =>
  api.post<CreateTipoDocumentoDeloitteRequest>('tiposDocumentoDeloitte', data);

export const updateTipoDocumentoDeloitte = (data: UpdateTipoDocumentoDeloitteRequest) =>
  api.put<UpdateTipoDocumentoDeloitteRequest>('tiposDocumentoDeloitte', data);

export const deleteTipoDocumentoDeloitte = (id: string) =>
  api.delete(`tiposDocumentoDeloitte/${id}`);
